import React, { useState } from "react";
import "../css/CashForCash.css";
import { printCashStatement } from "../utils/printCashStatement";

const denominations = [5000, 1000, 500, 100, 50, 20];

const CashForCashStatement = () => {
  const [inputs, setInputs] = useState(
    denominations.reduce((acc, val) => ({ ...acc, [val]: "" }), {})
  );

  const handleChange = (value, denom) => {
    setInputs((prev) => ({
      ...prev,
      [denom]: value,
    }));
  };

  const parseQuantity = (input) => {
    try {
      const cleaned = input.replace(/[^-()\d/*+.]/g, "");
      const result = eval(cleaned);
      return isNaN(result) || result < 0 ? 0 : Math.floor(result);
    } catch {
      return 0;
    }
  };

  const calculateTotal = () => {
    return denominations.reduce(
      (total, denom) => total + denom * parseQuantity(inputs[denom]),
      0
    );
  };

  const handleClear = () => {
    setInputs(denominations.reduce((acc, val) => ({ ...acc, [val]: "" }), {}));
  };

  const handlePrint = () => {
    const quantities = {};
    denominations.forEach((denom) => {
      quantities[denom] = parseQuantity(inputs[denom]);
    });
    printCashStatement(quantities);
  };

  return (
    <div className="cash-statement-container">
      <h2>Cash for Cash Statement</h2>
      <table className="cash-table">
        <thead>
          <tr>
            <th>Denomination</th>
            <th>Quantity</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {denominations.map((denom) => {
            const qty = parseQuantity(inputs[denom]);
            return (
              <tr key={denom}>
                <td>{denom}</td>
                <td>
                  <input
                    type="text"
                    value={inputs[denom]}
                    onChange={(e) => handleChange(e.target.value, denom)}
                  />
                </td>
                <td>${(denom * qty).toLocaleString()}</td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="2"><strong>Total</strong></td>
            <td><strong>${calculateTotal().toLocaleString()}</strong></td>
          </tr>
        </tfoot>
      </table>

      <div className="cash-actions">
        <button onClick={handleClear}>Clear</button>
        <button onClick={handlePrint}>Print</button>
      </div>
    </div>
  );
};

export default CashForCashStatement;
